<template lang="pug">
#modal-cadastrar-territorio-manual
    el-dialog(
        width='600px',
        title='Cadastrar Território',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-form(
            label-position='top',
            :model='dadosFormulario',
            :rules='rules',
            ref='dadosFormulario'
        )
            el-form-item(prop='car')
                template(slot='label')
                    span Numero do CAR

                el-input(
                    v-model='dadosFormulario.car',
                    placeholder='Digite o número do CAR'
                )

            el-form-item(prop='cpfCnpj')
                template(slot='label')
                    span.label-cnpj-cpf
                        span *
                        | CPF ou CNPJ

                el-input(
                    v-model='dadosFormulario.cpfCnpj',
                    placeholder='CPF ou CNPJ',
                    v-mask='["###.###.###-##", "##.###.###/####-##"]'
                )

        footer.espaco(slot='footer')
            el-button(
                type='primary',
                @click.prevent='adicionarTerritorioManual'
            ) Cadastrar Território
</template>

<script>
import validators from '@/utils/validators';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';

export default {
    name: 'SubEmpresaModalCadastrarTerritorioManual',

    props: {
        mostrar: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            dadosFormulario: {
                car: '',
                cpfCnpj: ''
            },
            rules: {
                car: [
                    {
                        required: true,
                        message: 'Informe um car válido',
                        trigger: 'blur'
                    }
                ],
                cpfCnpj: [{ validator: this.checkRuleCpfCnpj, trigger: 'blur' }]
            },
            mostrarModalDadosCadastroManual: false,
            dadosTerritorio: []
        };
    },

    computed: {
        cpfCnpjValido() {
            if (this.dadosFormulario.cpfCnpj) {
                return validators.validarCpfCnpj(this.dadosFormulario.cpfCnpj);
            }

            return false;
        }
    },

    methods: {
        async adicionarTerritorioManual() {
            this.$refs['dadosFormulario'].validate(valid => {
                if (valid) {
                    this.chamadaAdiconarTerritorio();
                } else {
                    return false;
                }
            });
        },
        async chamadaAdiconarTerritorio() {
            const dadosTerritorio = {
                carNumero: this.dadosFormulario.car,
                cpfCnpj: this.dadosFormulario.cpfCnpj
            };

            await ContratoOriginacaoServiceSubEmpresa.inserirTerritorio(
                dadosTerritorio
            )
                .then(({ data }) => {
                    this.limpar();
                    this.$emit('territorio-cadastrado', data);
                })
                .catch(erro => this.$notify.error(erro.response.data.message));
        },
        mostraModalDadosCadastroManual() {
            this.mostrarModalDadosCadastroManual = true;
        },
        checkRuleCpfCnpj(rule, value, callback) {
            if (
                !validators.validarCpfCnpj(this.dadosFormulario.cpfCnpj) ||
                !this.dadosFormulario.cpfCnpj
            ) {
                return callback(new Error('Informe um CPF/CNPJ válido'));
            }
            callback();
        },
        fechar() {
            this.limpar();
            this.$emit('fechar');
        },
        limpar() {
            this.$refs['dadosFormulario'].resetFields();
        }
    }
};
</script>

<style lang="scss">
#modal-cadastrar-territorio-manual {
    footer {
        display: flex;
        justify-content: flex-end;
    }

    .el-form-item .el-form-item__label {
        color: var(--text-disabled);
    }

    .espaco {
        display: flex;
    }

    span.label-cnpj-cpf span {
        color: #f78787;
        margin-right: 5px;
    }
}
</style>
